import { createFileRoute, redirect } from "@tanstack/react-router"

import { isPlatformLoggedIn, isTenantSubdomainHost } from "../../utils/platformAuth"

export const Route = createFileRoute("/platform/")({
  beforeLoad: async () => {
    if (isTenantSubdomainHost()) {
      throw redirect({ to: "/login" })
    }

    throw redirect({
      to: isPlatformLoggedIn() ? "/platform/spaces" : "/platform/login",
    })
  },
})
